export interface ChatMessage {
  id: number;
  userId: string;
  userName: string;
  userAvatar: string;
  userTier: string;
  userTierColor: string;
  userBadge?: string;
  content: string;
  timestamp: string;
  isModerator: boolean;
  isPinned: boolean;
  reactions: { emoji: string; count: number; reacted: boolean }[];
}

export interface ChatChannel {
  id: string;
  name: string;
  type: 'radio' | 'programa' | 'evento' | 'concurso';
  parentName: string;
  parentId: string;
  onlineCount: number;
  unreadCount: number;
  description: string;
  slowMode: boolean;
  slowModeSeconds: number;
  messages: ChatMessage[];
}

export interface ChatRoom {
  id: string;
  name: string;
  icon: string;
  iconBg: string;
  type: 'radio' | 'programa' | 'evento' | 'concurso';
  channels: ChatChannel[];
}

export const chatRooms: ChatRoom[] = [
  {
    id: 'radio-chats',
    name: 'Radios',
    icon: 'ri-radio-line',
    iconBg: 'bg-rose-500',
    type: 'radio',
    channels: [
      {
        id: 'ch-radio-exito',
        name: 'general',
        type: 'radio',
        parentName: 'Radio Éxito FM',
        parentId: 'radio-exito',
        onlineCount: 847,
        unreadCount: 12,
        description: 'Chat general de Radio Éxito FM. Compartí la experiencia con otros oyentes.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [
          { id: 1, userId: 'u1', userName: 'DJ Alexis', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20DJ%20portrait%20with%20headphones%20in%20modern%20studio%20warm%20lighting%20confident%20smile%20editorial%20style&width=80&height=80&seq=chat-user-dj-alexis&orientation=squarish', userTier: 'Moderador', userTierColor: 'text-primary-500', userBadge: '🎙️', content: '¡Buenas tardes a todos! ¿Cómo va ese viernes? 🎉', timestamp: new Date(Date.now() - 10 * 60000).toISOString(), isModerator: true, isPinned: false, reactions: [{ emoji: '❤️', count: 24, reacted: false }, { emoji: '🎉', count: 15, reacted: true }] },
          { id: 2, userId: 'u2', userName: 'Marco Rivera', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Hispanic%20male%20portrait%20friendly%20warm%20smile%20casual%20modern%20style%20clean%20background%20soft%20natural%20lighting&width=80&height=80&seq=chat-user-marco&orientation=squarish', userTier: 'Top Fan', userTierColor: 'text-orange-500', content: '¡Acá estamos! Viernes de éxitos 🚀', timestamp: new Date(Date.now() - 8 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '🔥', count: 8, reacted: false }] },
          { id: 3, userId: 'u3', userName: 'Lucía Mendoza', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latina%20female%20portrait%20fresh%20natural%20look%20warm%20friendly%20eyes%20clean%20soft%20background%20editorial%20photography&width=80&height=80&seq=chat-user-lucia&orientation=squarish', userTier: 'Fan', userTierColor: 'text-amber-500', content: 'Pongan el nuevo tema de Karol G porfa 🙏', timestamp: new Date(Date.now() - 5 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '👍', count: 12, reacted: false }, { emoji: '❤️', count: 5, reacted: false }] },
          { id: 4, userId: 'u4', userName: 'Pedro Castillo', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latino%20male%20portrait%20friendly%20approachable%20casual%20polo%20style%20clean%20background%20editorial%20photography&width=80&height=80&seq=chat-user-pedro&orientation=squarish', userTier: 'Nuevo', userTierColor: 'text-stone-500', content: 'Primera vez acá, ¡hola a todos! 👋', timestamp: new Date(Date.now() - 3 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '👋', count: 6, reacted: false }] },
          { id: 5, userId: 'u1', userName: 'DJ Alexis', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20male%20radio%20DJ%20portrait%20with%20headphones%20in%20modern%20studio%20warm%20lighting%20confident%20smile%20editorial%20style&width=80&height=80&seq=chat-user-dj-alexis&orientation=squarish', userTier: 'Moderador', userTierColor: 'text-primary-500', userBadge: '🎙️', content: '¡Bienvenido Pedro! @Lucía va el de Karol en 10 min 😉', timestamp: new Date(Date.now() - 2 * 60000).toISOString(), isModerator: true, isPinned: true, reactions: [{ emoji: '❤️', count: 31, reacted: false }, { emoji: '🔥', count: 18, reacted: true }, { emoji: '🎵', count: 9, reacted: false }] },
        ],
      },
      {
        id: 'ch-radio-exito-canciones',
        name: 'pedidos',
        type: 'radio',
        parentName: 'Radio Éxito FM',
        parentId: 'radio-exito',
        onlineCount: 234,
        unreadCount: 0,
        description: 'Canal de pedidos musicales. ¡Pedí tu canción favorita!',
        slowMode: true,
        slowModeSeconds: 30,
        messages: [
          { id: 10, userId: 'u6', userName: 'Ana Vega', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%20latina%20bright%20confident%20smile%20studio%20headphones%20clean%20background&width=80&height=80&seq=chat-user-ana&orientation=squarish', userTier: 'Locutora', userTierColor: 'text-emerald-500', userBadge: '🎤', content: '¡Canal de pedidos abierto! ¿Qué quieren escuchar?', timestamp: new Date(Date.now() - 25 * 60000).toISOString(), isModerator: true, isPinned: true, reactions: [] },
          { id: 11, userId: 'u7', userName: 'Carlos López', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latino%20male%20casual%20friendly%20portrait%20warm%20smile%20simple%20t-shirt%20clean%20background%20editorial&width=80&height=80&seq=chat-user-carlos-l&orientation=squarish', userTier: 'VIP', userTierColor: 'text-rose-500', content: 'Shakira - Acróstico porfa! Dedicado a mi hija Sofía ❤️', timestamp: new Date(Date.now() - 20 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '❤️', count: 15, reacted: false }] },
          { id: 12, userId: 'u6', userName: 'Ana Vega', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20female%20radio%20host%20portrait%20latina%20bright%20confident%20smile%20studio%20headphones%20clean%20background&width=80&height=80&seq=chat-user-ana&orientation=squarish', userTier: 'Locutora', userTierColor: 'text-emerald-500', userBadge: '🎤', content: '@CarlosLópez Anotado! Sale en el próximo bloque. ¡Saludos a Sofía! 🌸', timestamp: new Date(Date.now() - 18 * 60000).toISOString(), isModerator: true, isPinned: false, reactions: [{ emoji: '❤️', count: 22, reacted: true }] },
        ],
      },
      {
        id: 'ch-radio-exito-noticias',
        name: 'noticias',
        type: 'radio',
        parentName: 'Radio Éxito FM',
        parentId: 'radio-exito',
        onlineCount: 156,
        unreadCount: 0,
        description: 'Enterate de las novedades de la radio: eventos, sorteos, cambios de programación.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
    ],
  },
  {
    id: 'radio-chats-2',
    name: 'Radio Ritmo',
    icon: 'ri-music-2-line',
    iconBg: 'bg-emerald-500',
    type: 'radio',
    channels: [
      {
        id: 'ch-radio-ritmo-general',
        name: 'general',
        type: 'radio',
        parentName: 'Radio Ritmo',
        parentId: 'radio-ritmo',
        onlineCount: 1203,
        unreadCount: 45,
        description: 'Chat general de Radio Ritmo. ¡Puro sabor latino!',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [
          { id: 20, userId: 'u10', userName: 'DJ Lúcido', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20radio%20DJ%20afro-latino%20male%20late%2020s%20cool%20confident%20expression%20studio%20headphones%20clean%20background%20editorial&width=80&height=80&seq=chat-user-lucido&orientation=squarish', userTier: 'DJ', userTierColor: 'text-emerald-500', userBadge: '🎧', content: '¡Ritmo Urbano en vivo! ¿Quién está pegado? 🔊', timestamp: new Date(Date.now() - 15 * 60000).toISOString(), isModerator: true, isPinned: false, reactions: [{ emoji: '🔥', count: 48, reacted: false }, { emoji: '🎵', count: 32, reacted: true }] },
          { id: 21, userId: 'u11', userName: 'Valentina Ochoa', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latina%20female%20portrait%20fresh%20glowing%20smile%20casual%20trendy%20style%20clean%20background%20editorial%20photography&width=80&height=80&seq=chat-user-vale-o&orientation=squarish', userTier: 'Nuevo', userTierColor: 'text-stone-500', content: 'Pegadísima! Desde Medellín con toda 🔥🔥🔥', timestamp: new Date(Date.now() - 12 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '🇨🇴', count: 8, reacted: false }, { emoji: '🔥', count: 5, reacted: false }] },
        ],
      },
      {
        id: 'ch-radio-ritmo-vip',
        name: 'vip',
        type: 'radio',
        parentName: 'Radio Ritmo',
        parentId: 'radio-ritmo',
        onlineCount: 67,
        unreadCount: 0,
        description: 'Canal exclusivo para oyentes VIP y Top Fans.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
    ],
  },
  {
    id: 'programa-chats',
    name: 'Programas',
    icon: 'ri-mic-line',
    iconBg: 'bg-violet-500',
    type: 'programa',
    channels: [
      {
        id: 'ch-prog-manana',
        name: 'exitos-manana',
        type: 'programa',
        parentName: 'Éxitos de la Mañana',
        parentId: 'programa-exitos-manana',
        onlineCount: 523,
        unreadCount: 28,
        description: 'Chat del programa matutino. Saludá a Carlos y Ana en vivo.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [
          { id: 30, userId: 'u20', userName: 'Carlos Mendoza', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20radio%20host%20portrait%20hispanic%20male%2040s%20warm%20friendly%20smile%20studio%20headphones%20clean%20background&width=80&height=80&seq=chat-user-carlos-m&orientation=squarish', userTier: 'Locutor', userTierColor: 'text-primary-500', userBadge: '🎙️', content: '¡Buen día comunidad! Hoy tenemos entrevista exclusiva 🎤', timestamp: new Date(Date.now() - 30 * 60000).toISOString(), isModerator: true, isPinned: true, reactions: [{ emoji: '🎉', count: 67, reacted: false }, { emoji: '👏', count: 42, reacted: true }] },
          { id: 31, userId: 'u21', userName: 'Sofía Montoya', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latina%20female%20portrait%20bright%20curious%20expression%20casual%20chic%20style%20clean%20background&width=80&height=80&seq=chat-user-sofia-m&orientation=squarish', userTier: 'Fan', userTierColor: 'text-amber-500', content: 'Los escucho todas las mañanas! Son lo más ✨', timestamp: new Date(Date.now() - 25 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '❤️', count: 12, reacted: false }] },
        ],
      },
      {
        id: 'ch-prog-urbano',
        name: 'ritmo-urbano',
        type: 'programa',
        parentName: 'Ritmo Urbano',
        parentId: 'programa-ritmo-urbano',
        onlineCount: 891,
        unreadCount: 0,
        description: 'Chat del programa Ritmo Urbano con DJ Lúcido. ¡Reggaetón y más!',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
      {
        id: 'ch-prog-deep',
        name: 'deep-sessions',
        type: 'programa',
        parentName: 'Deep Sessions',
        parentId: 'programa-deep-sessions',
        onlineCount: 312,
        unreadCount: 0,
        description: 'Chat del programa Deep Sessions con DJ Nova. Electrónica y deep house.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
    ],
  },
  {
    id: 'evento-chats',
    name: 'Eventos',
    icon: 'ri-calendar-event-line',
    iconBg: 'bg-amber-500',
    type: 'evento',
    channels: [
      {
        id: 'ch-evento-festival',
        name: 'festival-sonoro',
        type: 'evento',
        parentName: 'Festival Sonoro RFW',
        parentId: 'evento-festival-sonoro',
        onlineCount: 2450,
        unreadCount: 156,
        description: 'Chat oficial del Festival Sonoro RFW 2026. ¡15 de Julio en Bogotá!',
        slowMode: true,
        slowModeSeconds: 15,
        messages: [
          { id: 40, userId: 'u30', userName: 'RFW Staff', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20radio%20network%20staff%20member%20portrait%20friendly%20corporate%20style%20clean%20modern%20background%20editorial%20photography&width=80&height=80&seq=chat-user-rfw-staff&orientation=squarish', userTier: 'Staff', userTierColor: 'text-rose-500', userBadge: '🛡️', content: '🎪 ¡BIENVENIDOS AL CHAT OFICIAL DEL FESTIVAL SONORO RFW 2026! Compartan su emoción, planes y encuentros.', timestamp: new Date(Date.now() - 120 * 60000).toISOString(), isModerator: true, isPinned: true, reactions: [{ emoji: '🎪', count: 245, reacted: false }, { emoji: '🔥', count: 189, reacted: true }, { emoji: '🎉', count: 156, reacted: false }] },
          { id: 41, userId: 'u31', userName: 'Julián Restrepo', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latino%20male%20portrait%20relaxed%20easygoing%20smile%20casual%20denim%20style%20clean%20background%20editorial&width=80&height=80&seq=chat-user-julian&orientation=squarish', userTier: 'VIP', userTierColor: 'text-rose-500', content: 'Ya tengo mi entrada VIP! Nos vemos en Bogotá 🎫✈️', timestamp: new Date(Date.now() - 90 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '🎫', count: 34, reacted: false }, { emoji: '✈️', count: 12, reacted: false }] },
          { id: 42, userId: 'u32', userName: 'Mariana Gil', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latina%20female%20portrait%20sweet%20genuine%20smile%20casual%20feminine%20style%20clean%20background%20editorial%20photography&width=80&height=80&seq=chat-user-mariana&orientation=squarish', userTier: 'Fan', userTierColor: 'text-amber-500', content: '¿Alguien sabe si van a vender merch oficial allá? Necesito la camiseta! 👕', timestamp: new Date(Date.now() - 60 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '👕', count: 18, reacted: false }, { emoji: '❓', count: 5, reacted: false }] },
          { id: 43, userId: 'u30', userName: 'RFW Staff', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20radio%20network%20staff%20member%20portrait%20friendly%20corporate%20style%20clean%20modern%20background%20editorial%20photography&width=80&height=80&seq=chat-user-rfw-staff&orientation=squarish', userTier: 'Staff', userTierColor: 'text-rose-500', userBadge: '🛡️', content: '@MarianaGil ¡Sí! Stand oficial con merch edición limitada del festival. Llegá temprano que vuela 🏃‍♂️', timestamp: new Date(Date.now() - 55 * 60000).toISOString(), isModerator: true, isPinned: false, reactions: [{ emoji: '🔥', count: 42, reacted: true }] },
        ],
      },
      {
        id: 'ch-evento-gala',
        name: 'gala-anual',
        type: 'evento',
        parentName: 'Gala Anual RFW',
        parentId: 'evento-gala-anual',
        onlineCount: 178,
        unreadCount: 0,
        description: 'Chat de la Gala Anual RFW 2026 en CDMX.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
    ],
  },
  {
    id: 'concurso-chats',
    name: 'Concursos',
    icon: 'ri-trophy-line',
    iconBg: 'bg-orange-500',
    type: 'concurso',
    channels: [
      {
        id: 'ch-concurso-voz',
        name: 'la-voz-rfw',
        type: 'concurso',
        parentName: 'Concurso La Voz RFW 2026',
        parentId: 'concurso-la-voz-rfw',
        onlineCount: 3840,
        unreadCount: 342,
        description: 'Chat oficial del concurso La Voz RFW 2026. ¡Inscripciones abiertas!',
        slowMode: true,
        slowModeSeconds: 10,
        messages: [
          { id: 50, userId: 'u40', userName: 'Coordinador RFW', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20event%20coordinator%20portrait%20latino%20warm%20smile%20organized%20desk%20setup%20clean%20modern%20background%20editorial&width=80&height=80&seq=chat-user-coord&orientation=squarish', userTier: 'Staff', userTierColor: 'text-rose-500', userBadge: '🛡️', content: '🎤 ¡LA VOZ RFW 2026 - INSCRIPCIONES ABIERTAS! Manden su demo de 60 segundos al link en la descripción. ¡El ganador tendrá su propio programa! 🏆', timestamp: new Date(Date.now() - 180 * 60000).toISOString(), isModerator: true, isPinned: true, reactions: [{ emoji: '🎤', count: 512, reacted: false }, { emoji: '🏆', count: 389, reacted: true }, { emoji: '🔥', count: 276, reacted: false }] },
          { id: 51, userId: 'u41', userName: 'Emilio Castro', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latino%20male%20portrait%20energetic%20sporty%20look%20fresh%20smile%20clean%20background%20editorial%20photography&width=80&height=80&seq=chat-user-emilio&orientation=squarish', userTier: 'Nuevo', userTierColor: 'text-stone-500', content: '¡Ya mandé mi demo! ¿Cuándo anuncian los seleccionados? 🤞', timestamp: new Date(Date.now() - 120 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '🤞', count: 24, reacted: false }, { emoji: '💪', count: 8, reacted: false }] },
          { id: 52, userId: 'u42', userName: 'Renata Suárez', userAvatar: 'https://readdy.ai/api/search-image?query=Young%20Latina%20female%20portrait%20elegant%20warm%20smile%20sophisticated%20casual%20look%20clean%20background%20editorial%20photography&width=80&height=80&seq=chat-user-renata&orientation=squarish', userTier: 'Top Fan', userTierColor: 'text-orange-500', content: 'Yo participé el año pasado y quedé en top 10. ¡Anímense que es una experiencia INCREÍBLE! ✨', timestamp: new Date(Date.now() - 90 * 60000).toISOString(), isModerator: false, isPinned: false, reactions: [{ emoji: '✨', count: 45, reacted: false }, { emoji: '👏', count: 32, reacted: false }] },
          { id: 53, userId: 'u40', userName: 'Coordinador RFW', userAvatar: 'https://readdy.ai/api/search-image?query=Professional%20event%20coordinator%20portrait%20latino%20warm%20smile%20organized%20desk%20setup%20clean%20modern%20background%20editorial&width=80&height=80&seq=chat-user-coord&orientation=squarish', userTier: 'Staff', userTierColor: 'text-rose-500', userBadge: '🛡️', content: '@EmilioCastro Los 50 seleccionados se anuncian el 1 de Julio. ¡Estén atentos! 📅 @RenataSuárez ¡Inspiración total! 🙌', timestamp: new Date(Date.now() - 80 * 60000).toISOString(), isModerator: true, isPinned: false, reactions: [{ emoji: '📅', count: 67, reacted: false }, { emoji: '🙌', count: 28, reacted: true }] },
        ],
      },
      {
        id: 'ch-concurso-podcast',
        name: 'mejor-podcast',
        type: 'concurso',
        parentName: 'Concurso Mejor Podcast RFW',
        parentId: 'concurso-mejor-podcast',
        onlineCount: 1240,
        unreadCount: 0,
        description: 'Votación abierta para el Mejor Podcast RFW.',
        slowMode: false,
        slowModeSeconds: 0,
        messages: [],
      },
    ],
  },
];

export const moderationPhrases = [
  '¡Mensaje eliminado por el moderador!',
  'Usuario silenciado por 5 minutos.',
  'Recordá mantener el respeto en el chat.',
  'Este canal tiene modo lento activado.',
  'Contenido bloqueado por filtro automático.',
];

export const quickEmojis = ['❤️', '🔥', '👏', '🎉', '😂', '💯', '🙌', '✨', '👍', '🎵'];